export const ACTION_MENU_DEFAULT_STATE = {
  anchorElement: null,
  id: "",
};
